import React, { useEffect, useState } from "react";
import imagelogo from "../Assert/Image/logo.png";
import userIcon from "../Assert/Image/announcement-bell.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaShareAlt,
  FaTachometerAlt,
  FaExclamationTriangle,
  FaTimes,
  FaSignOutAlt,
  FaBars,
  FaUserClock,
  FaUsers,
  FaThLarge,
  FaChevronDown,
  FaChevronRight,
  FaBell,
  FaSearch,
  FaMoon,
  FaSun,
  FaUserCircle,
  FaCog,
  FaQuestionCircle,
  FaChartLine,
} from "react-icons/fa";
import { TbUserCode } from "react-icons/tb";
import { FcManager } from "react-icons/fc";
import { LuMessagesSquare } from "react-icons/lu";
import { RiUserSettingsFill } from "react-icons/ri";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AiFillDashboard } from "react-icons/ai";
import { jwtDecode } from "jwt-decode";
import { CgProfile } from "react-icons/cg";
import { SiNginxproxymanager } from "react-icons/si";
import { MdAddTask, MdOutlineFileCopy, MdOutlineSendTimeExtension, MdPayments } from "react-icons/md";
import { MdQuestionAnswer } from "react-icons/md";
import { MdSpatialTracking } from "react-icons/md";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { MdFeedback } from "react-icons/md";
import { RiLogoutBoxFill } from "react-icons/ri";
import { BsKanbanFill } from "react-icons/bs";
import { FiClock } from "react-icons/fi";
import projectIcon from "../Assert/Image/iconprokect.png";

export default function App() {
  const userName = "Admin";
  const location = useLocation();
  const currentPath = location.pathname;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [darkMode, setDarkMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New task assigned", read: false },
    { id: 2, message: "Project deadline approaching", read: false },
    { id: 3, message: "New message from client", read: true },
  ]);
  
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  
  const toggleMenu = (menu) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };
  
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth >= 992) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = (e) => {
    const modal = window.bootstrap?.Modal.getInstance(document.getElementById('logoutModal'));
    if (modal) modal.hide();

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setSidebarOpen(false);
    toast.success("Logged out successfully");
    navigate("/adminlogin");
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserData(decoded);
      } catch (error) {
        console.error("Invalid Token", error);
      }
    }
  }, []);
  
  // Enhanced Color Scheme
  const colors = {
    primary: "#2E7D32",       // Deep Green
    secondary: "#FF9800",     // Orange
    accent: "#4CAF50",        // Light Green
    dark: "#1a1f2b",          // Dark Blue-Gray
    light: "#F5F5F5",         // Light Gray
    lightGreen: "#E8F5E9",    // Very Light Green
    lightOrange: "#FFF3E0",   // Very Light Orange
    danger: "#D32F2F",        // Red
    success: "#388E3C",       // Green
    info: "#0288D1",          // Blue
    warning: "#F57C00",       // Dark Orange
    gray100: "#f8f9fa",
    gray200: "#e9ecef",
    gray300: "#dee2e6",
    gray400: "#ced4da",
    gray500: "#adb5bd",
    gray600: "#6c757d",
    gray700: "#495057",
    gray800: "#343a40",
    gray900: "#212529",
  };

  // Filter menu items based on search
  const filterMenuItems = (items) => {
    if (!searchTerm) return items;
    return items.filter(item => 
      item.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Define menu structure with categories
  const menuStructure = {
    admin: [
      {
        category: "Administration",
        items: [
          { path: "/admin/dashboard", icon: FaTachometerAlt, label: "Dashboard" },
          { path: "/admin/Customerpost", icon: LuMessagesSquare, label: "Message" },
          { path: "/admin/SocialPost", icon: FaShareAlt, label: "Social Post" },
          { path: "/admin/Submenudetails", icon: FaThLarge, label: "Type Management" },
          { path: "/admin/ManageCustomers", icon: FaUsers, label: "Customers Management" },
          { path: "/admin/usermanagement", icon: FcManager, label: "Company User Management" },
          { path: "/admin/adddetailspage", icon: MdOutlineSendTimeExtension, label: "Customer Send Details" },
          { path: "/admin/developer", icon: TbUserCode, label: "Developer Page" },
          { path: "/admin/attendance", icon: FaUserClock, label: "Attendance Management" },
          { path: "/admin/project_management", icon: () => <img src={projectIcon} alt="Project" style={{ width: '20px', height: '20px' }} />, label: "Project Management" },
          { path: "/admin/taskmanagement", icon: MdAddTask, label: "Task Management" },
        ]
      }
    ],
    customer: [
      {
        category: "Customer Portal",
        items: [
          { path: "/customer/dashboard", icon: AiFillDashboard, label: "Dashboard Overview" },
          { path: "/customer/profileandaccount", icon: CgProfile, label: "Profile & Account" },
        ]
      },
      {
        category: "Project Management",
        items: [
          { path: "/customer/projectmanagement", icon: RiUserSettingsFill, label: "Project Management" },
        ]
      },
      {
        category: "Financial",
        items: [
          { path: "/customer/billinginvoices", icon: MdPayments, label: "Billing & Invoices" },
          { path: "/customer/quotationsproposals", icon: MdQuestionAnswer, label: "Quotations & Proposals" },
        ]
      },
      {
        category: "Support",
        items: [
          { path: "/customer/ticketSystem", icon: MdSpatialTracking, label: "Support / Ticketing" },
          { path: "/customer/documentsandresources", icon: MdOutlineSystemUpdateAlt, label: "Documents & Resources" },
          { path: "/customer/feedbackreviews", icon: MdFeedback, label: "Feedback & Reviews" },
        ]
      }
    ],
    developer: [
      {
        category: "Developer",
        items: [
          { path: "/developer/dashboard", icon: FaTachometerAlt, label: "Dashboard" },
          { path: "/developer/developerprofile", icon: CgProfile, label: "Profile Page" },
          { path: "/developer/ProgjectManagement", icon: BsKanbanFill, label: "Project Details" },
          { path: "/developer/filetransfers", icon: MdOutlineFileCopy, label: "File Transfer Method" },
          { path: "/developer/attendance", icon: FiClock, label: "Attendance Management" },
          { path: "/developer/tasktraking", icon: SiNginxproxymanager, label: "Task Tracking" },
        ]
      }
    ]
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <style>{`
        :root {
          --primary: ${colors.primary};
          --secondary: ${colors.secondary};
          --accent: ${colors.accent};
          --dark: ${colors.dark};
          --light: ${colors.light};
          --light-green: ${colors.lightGreen};
          --light-orange: ${colors.lightOrange};
          --danger: ${colors.danger};
          --success: ${colors.success};
          --info: ${colors.info};
          --warning: ${colors.warning};
        }
        
        body {
          background-color: #f9f9f9;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          margin: 0;
          padding: 0;
          color: ${colors.dark};
          overflow-x: hidden;
        }
        
        body.dark-mode {
          background-color: ${colors.dark};
          color: ${colors.light};
        }
        
        /* Main content area */
        @media (min-width: 992px) {
          main {
            padding-left: 280px;
            padding-top: 80px;
            transition: padding-left 0.3s ease;
          }
        }
        
        /* Enhanced Sidebar styles */
        .sidebar {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          padding: 80px 0 0;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          width: 280px;
          background: white;
          z-index: 1000;
          overflow-y: auto;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-right: 1px solid ${colors.gray200};
          transform: ${isMobile ? (sidebarOpen ? 'translateX(0)' : 'translateX(-100%)') : 'translateX(0)'};
        }
        
        .sidebar.dark-mode {
          background: ${colors.gray800};
          border-right-color: ${colors.gray700};
        }
        
        .sidebar-header {
          padding: 0 1.5rem 1.5rem;
          border-bottom: 1px solid ${colors.gray200};
          margin-bottom: 1rem;
        }
        
        .sidebar-header.dark-mode {
          border-bottom-color: ${colors.gray700};
        }
        
        .sidebar-brand {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-weight: 600;
          color: ${colors.primary};
          text-decoration: none;
        }
        
        .sidebar-brand img {
          height: 32px;
          transition: transform 0.3s ease;
        }
        
        .sidebar-brand:hover img {
          transform: scale(1.05);
        }
        
        /* Search bar */
        .sidebar-search {
          padding: 0 1.5rem 1rem;
        }
        
        .search-wrapper {
          position: relative;
        }
        
        .search-icon {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
          color: ${colors.gray500};
          font-size: 0.875rem;
        }
        
        .search-input {
          width: 100%;
          padding: 0.5rem 0.5rem 0.5rem 2rem;
          border: 1px solid ${colors.gray300};
          border-radius: 8px;
          font-size: 0.875rem;
          transition: all 0.3s ease;
        }
        
        .search-input:focus {
          outline: none;
          border-color: ${colors.primary};
          box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.1);
        }
        
        .search-input.dark-mode {
          background: ${colors.gray700};
          border-color: ${colors.gray600};
          color: ${colors.light};
        }
        
        /* Category sections */
        .sidebar-category {
          margin-bottom: 1.5rem;
        }
        
        .sidebar-category-header {
          padding: 0 1rem;
          margin-bottom: 0.5rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: ${colors.gray600};
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          transition: color 0.2s ease;
        }
        
        .sidebar-category-header:hover {
          color: ${colors.primary};
        }
        
        .sidebar-category-header.dark-mode {
          color: ${colors.gray400};
        }
        
        .sidebar-menu {
          padding: 0 1rem;
        }
        
        .sidebar-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem 1rem;
          margin-bottom: 0.25rem;
          border-radius: 8px;
          color: ${colors.gray700};
          font-weight: 500;
          transition: all 0.2s ease;
          text-decoration: none;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        
        .sidebar-item::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 3px;
          background: ${colors.primary};
          transform: scaleY(0);
          transition: transform 0.2s ease;
        }
        
        .sidebar-item:hover::before,
        .sidebar-item.active::before {
          transform: scaleY(1);
        }
        
        .sidebar-item:hover {
          background-color: ${colors.lightGreen};
          color: ${colors.primary};
          transform: translateX(5px);
        }
        
        .sidebar-item.active {
          background: linear-gradient(90deg, ${colors.lightGreen} 0%, transparent 100%);
          color: ${colors.primary};
          font-weight: 600;
        }
        
        .sidebar-item.active .sidebar-icon {
          color: ${colors.primary};
        }
        
        .sidebar-icon {
          font-size: 1.25rem;
          color: ${colors.gray500};
          transition: all 0.2s ease;
        }
        
        .sidebar-item:hover .sidebar-icon,
        .sidebar-item.active .sidebar-icon {
          transform: scale(1.1);
        }
        
        /* Badge for notifications */
        .sidebar-badge {
          margin-left: auto;
          background: ${colors.secondary};
          color: white;
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
          border-radius: 12px;
          min-width: 20px;
          text-align: center;
        }
        
        .sidebar-divider {
          border-top: 1px solid ${colors.gray200};
          margin: 1rem 0;
        }
        
        /* Enhanced Navbar */
        .navbar {
          height: 80px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
          background-color: white;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1100;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1.5rem;
          transition: all 0.3s ease;
        }
        
        .navbar.dark-mode {
          background: ${colors.gray800};
          color: ${colors.light};
        }
        
        .navbar-left {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .navbar-toggler {
          border: none;
          font-size: 1.25rem;
          color: ${colors.primary};
          background: none;
          padding: 0.5rem;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .navbar-toggler:hover {
          background-color: ${colors.lightGreen};
          transform: rotate(90deg);
        }
        
        .navbar-right {
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }
        
        /* Notification bell */
        .notification-bell {
          position: relative;
          cursor: pointer;
          padding: 0.5rem;
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        
        .notification-bell:hover {
          background-color: ${colors.lightGreen};
        }
        
        .notification-badge {
          position: absolute;
          top: 0;
          right: 0;
          background: ${colors.danger};
          color: white;
          font-size: 0.625rem;
          padding: 0.125rem 0.375rem;
          border-radius: 10px;
          min-width: 16px;
          text-align: center;
        }
        
        /* Theme toggle */
        .theme-toggle {
          cursor: pointer;
          padding: 0.5rem;
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        
        .theme-toggle:hover {
          background-color: ${colors.lightGreen};
        }
        
        /* User menu */
        .user-menu {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid ${colors.lightGreen};
          transition: transform 0.2s ease;
        }
        
        .user-avatar:hover {
          transform: scale(1.05);
        }
        
        .user-info {
          display: none;
        }
        
        @media (min-width: 768px) {
          .user-info {
            display: block;
          }
        }
        
        .user-name {
          font-weight: 600;
          font-size: 0.875rem;
          color: ${colors.dark};
        }
        
        .user-role {
          font-size: 0.75rem;
          color: ${colors.gray600};
        }
        
        .dropdown-menu {
          border: none;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          border-radius: 12px;
          padding: 0.5rem;
          min-width: 200px;
          animation: slideDown 0.2s ease;
        }
        
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .dropdown-item {
          padding: 0.625rem 1rem;
          border-radius: 8px;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .dropdown-item:hover {
          background-color: ${colors.lightGreen};
          color: ${colors.primary};
          transform: translateX(5px);
        }
        
        /* Overlay for mobile */
        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.5);
          z-index: 900;
          opacity: ${sidebarOpen && isMobile ? '1' : '0'};
          visibility: ${sidebarOpen && isMobile ? 'visible' : 'hidden'};
          transition: opacity 0.3s ease, visibility 0.3s ease;
          backdrop-filter: blur(4px);
        }
        
        /* Modal styles */
        .logout-modal .modal-content {
          border: none;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
        }
        
        .logout-modal .modal-header {
          background: linear-gradient(135deg, ${colors.primary}, ${colors.accent});
          border-bottom: none;
          padding: 1.5rem;
        }
        
        .logout-modal .modal-body {
          padding: 2rem;
          text-align: center;
        }
        
        .logout-modal .modal-footer {
          border-top: none;
          padding: 1.5rem;
          justify-content: center;
          gap: 1rem;
        }
        
        .btn-outline-secondary {
          border-color: ${colors.gray300};
          color: ${colors.gray600};
        }
        
        .btn-outline-secondary:hover {
          background-color: ${colors.lightGreen};
          border-color: ${colors.primary};
          color: ${colors.primary};
        }
        
        .btn-danger {
          background: ${colors.danger};
          border: none;
        }
        
        .btn-danger:hover {
          background: ${colors.danger};
          filter: brightness(0.9);
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .navbar {
            padding: 0 1rem;
          }
          
          .sidebar {
            width: 260px;
          }
          
          .navbar-right {
            gap: 0.75rem;
          }
        }
        
        @media (max-width: 576px) {
          .navbar-brand img {
            height: 24px;
          }
          
          .user-avatar {
            width: 32px;
            height: 32px;
          }
          
          .user-name {
            display: none;
          }
        }
        
        /* Scrollbar styling */
        .sidebar::-webkit-scrollbar {
          width: 4px;
        }
        
        .sidebar::-webkit-scrollbar-track {
          background: ${colors.gray200};
        }
        
        .sidebar::-webkit-scrollbar-thumb {
          background: ${colors.primary};
          border-radius: 4px;
        }
        
        .sidebar::-webkit-scrollbar-thumb:hover {
          background: ${colors.accent};
        }
      `}</style>

      <header>
        <nav 
          id="sidebarMenu"
          className={`sidebar ${darkMode ? 'dark-mode' : ''}`}
          aria-label="Sidebar navigation"
        >
          <div className="position-sticky">
            {/* Search Bar */}
            <div className="sidebar-search">
              <div className="search-wrapper">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  className={`search-input ${darkMode ? 'dark-mode' : ''}`}
                  placeholder="Search menu..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="sidebar-menu">
              {/* Admin Menu Section */}
              {(userData?.role === "Admin" || userData?.role === "Manager" || userData?.role === "Customer Care") && (
                <div className="sidebar-category">
                  <div 
                    className={`sidebar-category-header ${darkMode ? 'dark-mode' : ''}`}
                    onClick={() => toggleMenu('admin')}
                  >
                    <span>Administration</span>
                    {expandedMenus.admin ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
                  </div>
                  
                  {(expandedMenus.admin || !expandedMenus.admin) && menuStructure.admin[0].items
                    .filter(item => item.label.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((item, index) => (
                      <Link
                        key={index}
                        to={item.path}
                        className={`sidebar-item ${currentPath === item.path ? "active" : ""}`}
                        onClick={() => setSidebarOpen(false)}
                      >
                        {typeof item.icon === 'function' ? (
                          item.icon()
                        ) : (
                          <item.icon className="sidebar-icon" />
                        )}
                        <span>{item.label}</span>
                      </Link>
                    ))}
                </div>
              )}
              
              {/* Customer Menu Section */}
              {(userData?.role === "customer") && (
                <>
                  {menuStructure.customer.map((category, catIndex) => (
                    <div key={catIndex} className="sidebar-category">
                      <div 
                        className={`sidebar-category-header ${darkMode ? 'dark-mode' : ''}`}
                        onClick={() => toggleMenu(`customer-${catIndex}`)}
                      >
                        <span>{category.category}</span>
                        {expandedMenus[`customer-${catIndex}`] ? 
                          <FaChevronDown size={12} /> : 
                          <FaChevronRight size={12} />
                        }
                      </div>
                      
                      {(expandedMenus[`customer-${catIndex}`] || !expandedMenus[`customer-${catIndex}`]) && 
                        category.items
                          .filter(item => item.label.toLowerCase().includes(searchTerm.toLowerCase()))
                          .map((item, index) => (
                            <Link
                              key={index}
                              to={item.path}
                              className={`sidebar-item ${currentPath === item.path ? "active" : ""}`}
                              onClick={() => setSidebarOpen(false)}
                            >
                              <item.icon className="sidebar-icon" />
                              <span>{item.label}</span>
                            </Link>
                          ))
                      }
                    </div>
                  ))}
                </>
              )}
              
              {/* Developer Menu Section */}
              {(userData?.role === "Developer" || userData?.role === "Designer") && (
                <div className="sidebar-category">
                  <div 
                    className={`sidebar-category-header ${darkMode ? 'dark-mode' : ''}`}
                    onClick={() => toggleMenu('developer')}
                  >
                    <span>Developer</span>
                    {expandedMenus.developer ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
                  </div>
                  
                  {(expandedMenus.developer || !expandedMenus.developer) && menuStructure.developer[0].items
                    .filter(item => item.label.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((item, index) => (
                      <Link
                        key={index}
                        to={item.path}
                        className={`sidebar-item ${currentPath === item.path ? "active" : ""}`}
                        onClick={() => setSidebarOpen(false)}
                      >
                        <item.icon className="sidebar-icon" />
                        <span>{item.label}</span>
                      </Link>
                    ))}
                </div>
              )}

              <div className="sidebar-divider"></div>
              
              <button
                className="sidebar-item"
                data-bs-toggle="modal"
                data-bs-target="#logoutModal"
                onClick={() => setSidebarOpen(false)}
              >
                <RiLogoutBoxFill className="sidebar-icon" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </nav>

        {/* Enhanced Navbar */}
        <nav
          className={`navbar navbar-expand-lg ${darkMode ? 'dark-mode' : ''}`}
          style={{
            backgroundColor: darkMode ? colors.gray800 : 
              userData?.role === "customer"
                ? "#e4e433d9"
                : userData?.role === "Admin"
                ? "rgb(118 207 118)"
                : "white"
          }}
        >
          <div className="navbar-left">
            <button
              className="navbar-toggler"
              type="button"
              aria-label="Toggle sidebar"
              onClick={toggleSidebar}
            >
              <FaBars />
            </button>

            <Link className="navbar-brand" to="#" onClick={() => setSidebarOpen(false)}>
              <img src={imagelogo} height="30" alt="Logo" loading="lazy" />
            </Link>
          </div>

          <div className="navbar-right">
            {/* Notification Bell */}
            <div className="notification-bell">
              <FaBell size={20} />
              {notifications.filter(n => !n.read).length > 0 && (
                <span className="notification-badge">
                  {notifications.filter(n => !n.read).length}
                </span>
              )}
            </div>

            {/* Theme Toggle */}
            <div 
              className="theme-toggle"
              onClick={() => setDarkMode(!darkMode)}
            >
              {darkMode ? <FaSun size={20} /> : <FaMoon size={20} />}
            </div>

            {/* User Menu */}
            <div className="user-menu">
              <div className="dropdown">
                <button
                  className="nav-link dropdown-toggle d-flex align-items-center bg-transparent border-0"
                  id="userDropdown"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={userIcon}
                    alt="User Icon"
                    className="user-avatar me-2"
                  />
                  <div className="user-info">
                    <div className="user-name">{userName}</div>
                    <div className="user-role">{userData?.role || 'User'}</div>
                  </div>
                </button>
                <ul 
                  className="dropdown-menu dropdown-menu-end shadow" 
                  aria-labelledby="userDropdown"
                  style={{ zIndex: 2000 }}
                >
                  <li>
                    <Link 
                      className="dropdown-item" 
                      to="/profile" 
                      onClick={() => setSidebarOpen(false)}
                    >
                      <FaUserCircle className="me-2" />
                      My Profile
                    </Link>
                  </li>
                  <li>
                    <Link 
                      className="dropdown-item" 
                      to="/settings" 
                      onClick={() => setSidebarOpen(false)}
                    >
                      <FaCog className="me-2" />
                      Settings
                    </Link>
                  </li>
                  <li>
                    <Link 
                      className="dropdown-item" 
                      to="/help" 
                      onClick={() => setSidebarOpen(false)}
                    >
                      <FaQuestionCircle className="me-2" />
                      Help & Support
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider my-1" /></li>
                  <li>
                    <button 
                      className="dropdown-item" 
                      onClick={handleLogout}
                    >
                      <RiLogoutBoxFill className="me-2" />
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>

        {sidebarOpen && isMobile && (
          <div className="sidebar-overlay" onClick={toggleSidebar} />
        )}
      </header>

      {/* Logout Modal */}
      <div
        className="modal fade logout-modal"
        id="logoutModal"
        tabIndex="-1"
        aria-labelledby="logoutModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title d-flex align-items-center text-white">
                <FaExclamationTriangle className="me-2" />
                Confirm Logout
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png"
                alt="logout"
                width="80"
                className="mb-3"
              />
              <p className="fs-5 fw-semibold text-muted mb-0">
                Are you sure you want to log out?
              </p>
              <p className="text-muted small mt-2">
                You'll need to login again to access your account
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                data-bs-dismiss="modal"
              >
                <FaTimes className="me-2" />
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger px-4"
                onClick={handleLogout}
              >
                <FaSignOutAlt className="me-2" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}